import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { cn } from '../lib/utils';
const PRODUCT_URL = 'https://rylte.com/products/augenfrisch';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  icon?: boolean;
  href?: string;
}
export function CTAButton({
  children,
  className,
  icon = true,
  href = PRODUCT_URL
}: CTAButtonProps) {
  return <motion.a href={href} target="_blank" rel="noopener noreferrer" whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={cn('inline-flex items-center justify-center gap-2 bg-brand-700 text-white px-8 py-4 rounded-full font-medium text-lg shadow-lg shadow-brand-700/20 hover:bg-brand-800 transition-colors w-full sm:w-auto no-underline cursor-pointer', className)} data-id="element-9">
      {children}
      {icon && <ArrowRight className="w-5 h-5" data-id="element-10" />}
    </motion.a>;
}